import * as React from 'react'
import { ReactElement, useContext, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import FileMessage from '../../components/FileMessage/FileMessage'
import MessageContext from '../../context/MessageContext'
import GlobalEmailFilingOverview from './GlobalEmailFilingOverview'
import { MenuItemKey } from '../../components/MainMenu'
import { AppAction, AppContext } from '../../config/appConfig'
import { useDispatch } from 'react-redux'
import { FileAction } from '../../config/fileConfig'
import { isAppContext } from '../../helpers/appHelper'

export default function GlobalEmailOverview(): ReactElement {
    const dispatch = useDispatch()
    const { outlookMessage } = useContext(MessageContext)

    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Emails] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [])

    // A compose message is not stored yet, so there is nothing to file here (HAM-4227).
    if (isAppContext(AppContext.Compose)) {
        return <Redirect to="/" />
    }

    if (outlookMessage) {
        return <FileMessage />
    }

    return <GlobalEmailFilingOverview />
}
